import React, {PureComponent} from 'react';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import LazyLoad from '../lazy-image/react-lazyload/index';
import PriceLabel from './PriceLabel';

function imageLoaded() {
}

function placeholderImage(altText) {
    return (
        <div
            className="placeholder"
            alt={altText}
        />
    );
}

export class RatioCard extends PureComponent {
    render() {
        const {
            getImageUrl,
            path,
            linkRel,
            title,
            footer,
            onClick,
            aspectRatio = '3x4',
            horizontalScrollContainer = '',
            altText,
            priceLabel
        } = this.props;

        const link = {
            href: path,
            rel: linkRel
        };

        const imageUri = getImageUrl('xs');

        const placeholder = placeholderImage('');
        const priceLabelComponent = priceLabel ? <PriceLabel text={priceLabel.price} /> : null;

        const cardComponent = (
            <a {...link} onClick={onClick} className="RatioCard RatioCard__priceLabel" title={title}>
                <AspectRatioCard aspectRatio={aspectRatio} key={imageUri} async>
                    <div data-slot={'figure'} className="RatioCard__img-container" onLoad={imageLoaded}>
                        <LazyLoad once offset={250} placeholder={placeholder} addListener={horizontalScrollContainer}>
                            <img src={imageUri} alt={altText}/>
                        </LazyLoad>
                    </div>
                    <div data-slot={'caption'} className="RatioCard__caption">
                        <h4>{title}</h4>
                    </div>
                    <div data-slot={'content'} className="RatioCard__content">
                        {priceLabelComponent}
                        <div>{footer}</div>
                    </div>
                </AspectRatioCard>
            </a>
        );

        return cardComponent;
    }
}
